import {createContext, useContext} from 'react';
import {useTranslation} from 'react-i18next';

// Language of the current page, taken from the /:lang/ part of the URL
export const LangContext = createContext('en');

// t() pinned to the page language, so a page never renders in the wrong one
export const useLang = () => {
  const lang = useContext(LangContext);
  const {t} = useTranslation('translation', {lng: lang});
  return {lang, t};
};
